import React, { useState } from 'react';
import Modal from 'react-modal';

type TimesheetCancelModalProps = {
    isOpen: boolean;
    isCancelling?: boolean;
    onClose: () => void;
    onConfirm: (reason: string) => void;
};

export const TimesheetCancelModal: React.FC<TimesheetCancelModalProps> = ({
    isOpen,
    isCancelling = false,
    onClose,
    onConfirm,
}) => {
    const [reason, setReason] = useState('');
    const [error, setError] = useState('');

    const handleConfirm = () => {
        if (!reason.trim()) {
            setError('Cancellation reason is required.');
            return;
        }
        setError('');
        onConfirm(reason.trim());
    };

    const handleClose = () => {
        if (isCancelling) return;
        setReason('');
        setError('');
        onClose();
    };

    const handleReasonChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setReason(e.target.value);
        if (error) setError('');
    };

    return (
        <Modal
            className="timesheet-cancel-modal"
            isOpen={isOpen}
            onRequestClose={handleClose}
            contentLabel="Cancel Timesheet"
            ariaHideApp={false}
        >
            <div className="timesheet-cancel-modal__body">
                <h3 className="timesheet-cancel-modal__title">Cancel Timesheet</h3>
                <p className="timesheet-cancel-modal__description">
                    Please provide a reason for cancelling this timesheet. This will be recorded in the history log.
                </p>
                <textarea
                    className={`timesheet-cancel-modal__textarea${error ? ' timesheet-cancel-modal__textarea--error' : ''}`}
                    placeholder="Enter cancellation reason..."
                    value={reason}
                    onChange={handleReasonChange}
                    disabled={isCancelling}
                    rows={4}
                />
                {error && <p className="timesheet-cancel-modal__error">{error}</p>}
            </div>
            <div className="timesheet-cancel-modal__actions">
                <button
                    className="timesheet-modal__secondary-btn"
                    type="button"
                    onClick={handleClose}
                    disabled={isCancelling}
                >
                    CLOSE
                </button>
                <button
                    className="timesheet-modal__danger-btn"
                    type="button"
                    onClick={handleConfirm}
                    disabled={isCancelling || !reason.trim()}
                >
                    {isCancelling ? 'CANCELLING...' : 'CONFIRM CANCEL'}
                </button>
            </div>
        </Modal>
    );
};

export default TimesheetCancelModal;
